module.exports = __webpack_public_path__ + "img/logo.41660a3a.jpg";